import { Component, Input, Output, EventEmitter, OnInit, SimpleChanges, ViewChild } from '@angular/core';
import { FormControl, FormGroup } from '@angular/forms';
import { MatDialog, MatSidenav } from '@angular/material';
import { ActivatedRoute, Router } from '@angular/router';
import { Observable } from 'rxjs';
import { NewFileModalComponent } from 'src/app/files/new-file-modal/new-file-modal.component';
import { AssetService } from 'src/app/services/asset.service';
import { UserDocumentService } from 'src/app/services/user-document.service';
import { SideNavServiceService } from '../../services/side-nav-service.service'
import { UtilityService } from 'src/app/services/utility.service';
import * as _ from 'lodash';
declare var $: any;

@Component({
  selector: 'app-first-aid-checklist',
  templateUrl: './first-aid-checklist.component.html',
  styleUrls: ['./first-aid-checklist.component.scss']
})
export class FirstAidChecklistComponent implements OnInit {

  firstAidForm: FormGroup
  assetId
  userId: any;
  loading
  materials: any;
  firstAidFormData = []
  selectedIndex
  selectedFormDetails
  isEdit: Boolean
  userDetails
  userName
  formDetails
  assetDetails
  files: any = [];
  newFiles: any = [];
  @Output() getFileDetails: EventEmitter<any> = new EventEmitter<any>();
  @Output() openFilesSideNav: EventEmitter<any> = new EventEmitter();
  @ViewChild('sidenav', { static: false }) public mydsidenav: MatSidenav;
  previousIndex: any;
  @Input('asset') assetData
  @Input('user') userData
  @Input('documentData') documentDetails
  currentUser: any;
  _isControlDisable = false
  constructor(
    public _sidenavService: SideNavServiceService,
    public dialog: MatDialog,
    public router: Router,
    public activatedRouter: ActivatedRoute,
    public _assetService: AssetService,
    public _utilityService: UtilityService,
    public _userDocumentService: UserDocumentService,
  ) { }

  ngOnInit() {
    this.activatedRouter.params.subscribe(params => {
      // this.dataSource = new MatTableDataSource(this.userList);
      this.assetId = params.id;
      console.log('check params data..', params, this.assetId)
      // this.getSingleAseetDetails()
    })
    this.currentUser = JSON.parse(localStorage.getItem('currentUser'))
    console.log("this.currentUser", this.currentUser);

    this.createForm();
  }

  ngOnChanges(changes: SimpleChanges): void {
    console.log("First-Aid changes", changes);
    if (changes.assetData && changes.assetData.currentValue) {
      this.assetData = changes.assetData.currentValue
      console.log("this.assetData", this.assetData);
    }

    if (changes.userData && changes.userData.currentValue) {
      this.userId = changes.userData.currentValue
      console.log("this.userData", this.userData);
    }

    if (changes.documentDetails && changes.documentDetails.currentValue) {

      let data = changes.documentDetails.currentValue
      console.log("data--->", data);
      let tempData = data
      // let element = data.find((x) => x.userDocumentId.documentMetaId.title === 'firstAidForm')
      // console.log("single element details", element);

      let allFormList = data.filter((x) => x.userDocumentId.documentMetaId.title === 'firstAidForm')
      console.log("same for data for multiple forms", allFormList);

      if (allFormList && allFormList.length) {
        this.firstAidFormData = allFormList
        this.selectedIndex = this.firstAidFormData[0]._id
        this.selectedFormDetails = this.firstAidFormData[0].userDocumentId
        this._isControlDisable = true
        this.createForm(this.firstAidFormData[0].userDocumentId.details.inspectionForm)
        this.changeFormData()
      }
    }
  }


  //CREATE FORM

  createForm(data?) {
    console.log("data", data);

    this.firstAidForm = new FormGroup({
      plasterDate: new FormControl((data && data.plasterDate) ? data.plasterDate : ''),
      washproofDate: new FormControl((data && data.washproofDate) ? data.washproofDate : ''),
      msterileDate: new FormControl((data && data.msterileDate) ? data.msterileDate : ''),
      lsterileDate: new FormControl((data && data.lsterileDate) ? data.lsterileDate : ''),
      eyepadDate: new FormControl((data && data.eyepadDate) ? data.eyepadDate : ''),
      glovesDate: new FormControl((data && data.glovesDate) ? data.glovesDate : ''),
      wipesDate: new FormControl((data && data.wipesDate) ? data.wipesDate : ''),
      bandageDate: new FormControl((data && data.bandageDate) ? data.bandageDate : ''),
      safetypinDate: new FormControl((data && data.safetypinDate) ? data.safetypinDate : ''),
      leafletDate: new FormControl((data && data.leafletDate) ? data.leafletDate : ''),
      notes: new FormControl((data && data.notes) ? data.notes : ''),
    })
    if (this._isControlDisable) {
      this.firstAidForm.disable()
    }
  }


  // UTILITY

  onChangeEvent(value, formGroup, formControl) {
    console.log("value, formControl, formGroup", value, formControl, formGroup);

    if (formGroup == 'firstAidForm')
      this.firstAidForm.get(formControl).setValue(value);

  }

  changeFormData() {
    this.files = this.selectedFormDetails.files && this.selectedFormDetails.files.length ? this.selectedFormDetails.files : []
    this.isEdit = true
    this.createForm(this.selectedFormDetails.details.firstAidForm)
  }

  addNewForm() {
    this._assetService.closeDisplayFile(true)
    let obj = {
      _id: 'new',
      submissionDate: new Date(),
      userDocumentId: {}
    }
    let details = {}
    details['firstAidForm'] = {}
    obj.userDocumentId['details'] = details
    this.firstAidFormData.push(obj)
    this.selectedIndex = this.firstAidFormData[this.firstAidFormData.length - 1]._id
    this.selectedFormDetails = this.firstAidFormData[this.firstAidFormData.length - 1].userDocumentId
    this._isControlDisable = false
    this.createForm()
    this.isEdit = false
    this.files = []
  }


  changeEvent(event, id, index) {
    console.log("event", event);
    console.log("id", id);
    console.log("firstAidFormData", this.firstAidFormData);
    console.log("index", index);
    this.selectedIndex = this.firstAidFormData[index]._id
    this.selectedFormDetails = this.firstAidFormData[index].userDocumentId
    if (this.selectedIndex !== 'new') {
      this._isControlDisable = true
    } else {
      this._isControlDisable = false
    }
    this.changeFormData()
  }

  openDialog(someComponent, data = {}): Observable<any> {
    console.log("OPENDIALOG", "DATA = ", data);
    const dialogRef = this.dialog.open(someComponent, {
      data, maxWidth: '100vw',
      maxHeight: '100vh',
      height: '100%',
      width: '100%'
    });
    return dialogRef.afterClosed();
  }

  addFileModal() {


    let obj = {
      isIncident: true
    }

    // if (this.materialId != undefined) {
    let addedCourse = this.openDialog(NewFileModalComponent, obj).subscribe((fileQueue) => {
      console.log("The queue recieved is", fileQueue);
      if (fileQueue == undefined || fileQueue.length == 0) return;

      _.forEach(fileQueue, (file) => {
        if (this.isEdit) {
          this.newFiles.push(file)
        } else {
          this.files.push(file);
        }
      })

      // console.log("file value after push", this.files);
      this._utilityService.handleSnackBar({ msg: "File uploaded successfully!", button: "OK" })

    }, err => {
      this._utilityService.handleSnackBar({ msg: "Something went wrong!", button: "OK" })
    });
  }

  deleteFile(event, index) {
    console.log("event if file removed", event, this.isEdit);
    this.files.splice(index, 1)
    console.log("after file removd", this.files);

  }
  deleteNewFile(event, index) {
    console.log("before new files added", this.newFiles);
    console.log("this is the index and id", event, index);

    this.newFiles.splice(index, 1)

    console.log("after new file removed", this.newFiles);

  }



  //API CALL

  onSubmit() {
    console.log("this.firstAidForm", this.firstAidForm.value);
    this.loading = true
    if (this.isEdit) {
      let obj = {
        metaObj: {
          title: 'firstAidForm',
        },
        documentId: this.selectedFormDetails.documentId,
        userId: this.userId,
        onModel: 'asset',
        documentMetaId: this.selectedFormDetails.documentMetaId,
        userDocumentId: this.selectedFormDetails._id,
        files: this.files,
        newFiles: this.newFiles,
        details: {}
      }
      let details = {
        firstAidForm: this.firstAidForm.value
      }
      obj['details'] = details
      this._userDocumentService.updateUserDocument(obj).subscribe((response) => {
        console.log("response of new user document", response);
        this._utilityService.handleSnackBar({ msg: "Data updated successfully!", button: "OK" })
        this.loading = false
        this.redirect()
      }, error => {
        console.log("error while submit form", error);
        this._utilityService.handleSnackBar({ msg: "Something went wrong!", button: "OK" })
        this.loading = false
      })
    }

    else {
      let obj = {
        metaObj: {
          title: 'firstAidForm',
        },
        documentId: this.assetId,
        userId: this.userId,
        onModel: 'asset',
        files: this.files,
        // documentId: this.planFormDetails._id,
        details: {}
      }
      let details = {
        firstAidForm: this.firstAidForm.value
      }
      obj['details'] = details

      console.log("here is the asset Id", this.assetId)
      this._assetService.submitAssetForm(obj).subscribe((response) => {
        console.log("response of new user document", response);
        this.loading = false
        this._utilityService.handleSnackBar({ msg: "Data added successfully!", button: "OK" })
        this.redirect()
      }, error => {
        console.log("error while submit form", error);
        this._utilityService.handleSnackBar({ msg: "Something went wrong!", button: "OK" })
        this.loading = false
      })
      // this._utilityService.handleSnackBar({ msg: "Inspection form submitted successfully!", button: "OK" })
    }
  }

  redirect() {
    this._assetService.closeDisplayFile(true)
    if (this.currentUser && (this.currentUser.userRole.includes('admin') || this.currentUser.userRole.includes('assetManager'))) {
      console.log("user is admin");
      this.router.navigate(['/asset/single-asset/' + this.assetData])
    }
    else {
      this.router.navigate(['/asset/asset-list/'])
    }
  }

  fileDetails(event) {
    console.log("event ====", event);
    this.previousIndex = event.index
    // this._sidenavService.setSidenav(event)
    this.openFilesSideNav.emit({ event })
  }

}
